import { BasicIcon, Tooltip } from "@pickit/pickit-components";
import { Form } from "react-final-form";
import { formatDDMMYYYY, formatHHMM } from "utils/date";
import RainInputs from "../rainInputs/RainInputsContainer";
import { RainListPropsType } from "./types";
import "../RainBonusModal.scss";
import classNames from "classnames";
import { RainInputsValuesType } from "../types";
import { useTranslation } from "react-i18next";
import useValidationSchema from "hooks/useValidationSchema";

export const RainList = ({
  rains,
  type,
  rainDirty,
  validationSchema,
  validatingRainTime,
  dirtyRainRef,
  testId,
  deleteRain,
  updateRain,
  setRainDirty,
  resetValidation,
}: RainListPropsType): JSX.Element => {
  const { t } = useTranslation();
  const validation = useValidationSchema(validationSchema);
  return (
    <>
      {rains.length > 0 ? (
        rains.map((rain, index) => {
          const initialValues = {
            rainDate: formatDDMMYYYY(rain.startAt),
            rainTime: {
              initial: formatHHMM(rain.startAt),
              end: formatHHMM(rain.finishAt),
            },
          };
          return (
            <Form
              onSubmit={(values: RainInputsValuesType) => {}}
              initialValues={initialValues}
              validate={validation}
              keepDirtyOnReinitialize
              mutators={{
                setValue: ([field], state) => {
                  setRainDirty(!state.formState.pristine);
                  if (field === "rainTime.initial") {
                    const f = state.fields["rainTime.end"];
                    f.touched = true;
                  }
                },
              }}
            >
              {({ handleSubmit, form, values, dirty, invalid }) => (
                <form className="container-modal-rain-form">
                  <div
                    className="container-modal-rain-form-row rain-inputs-container"
                    ref={rainDirty && dirty ? dirtyRainRef : undefined}
                  >
                    <RainInputs
                      disabled={type === "PREVIOUS" || (rainDirty && !dirty)}
                      disableDate
                      form={form}
                      type="update"
                      rainId={rain.id}
                      testId={`${testId}-${index + 1}`}
                    />
                    <div className="container-modal-rain-form-col-1">
                      <div
                        className={classNames("modify-rain-buttons-container", {
                          active: dirty,
                        })}
                      >
                        {type === "NEXT" && dirty && (
                          <Tooltip message="Restablecer">
                            <button
                              type="button"
                              className="delete-rain"
                              onClick={() => {
                                setRainDirty(false);
                                form.change("rainTime", initialValues.rainTime);
                                form.change("rainDate", initialValues.rainDate);
                                form.restart();
                                resetValidation();
                              }}
                              data-testId={`${testId}-${index + 1}-refresh`}
                            >
                              <BasicIcon name="refresh" size="small" />
                            </button>
                          </Tooltip>
                        )}
                        {(!rainDirty || dirty) && (
                          <button
                            className="delete-rain"
                            type="button"
                            onClick={() => {
                              setRainDirty(false);
                              deleteRain(rain.id);
                            }}
                            data-testId={`${testId}-${index + 1}-delete`}
                          >
                            <BasicIcon name="trash" size="small" />
                          </button>
                        )}
                        {type === "NEXT" && dirty && (
                          <button
                            className="modify-rain"
                            type="button"
                            disabled={
                              invalid ||
                              validatingRainTime ||
                              !!form.getState().active
                            }
                            onClick={() => {
                              setRainDirty(false);
                              updateRain({
                                requestParams: {
                                  startAt: values.rainTime.initial || "",
                                  finishAt: values.rainTime.end || "",
                                },
                                rainId: rain.id,
                              });
                            }}
                            data-testId={`${testId}-${index + 1}-modify`}
                          >
                            <BasicIcon
                              name="check"
                              color="#ffffff"
                              size="small"
                            />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Form>
          );
        })
      ) : (
        <div className="no-results-rains">{t("rainBonus:noResults")}</div>
      )}
    </>
  );
};
